'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _class, _class2, _temp;
// styled


var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _getNested = require('get-nested');

var _getNested2 = _interopRequireDefault(_getNested);

var _mobxReact = require('mobx-react');

var _Parser = require('../Parser');

var _Parser2 = _interopRequireDefault(_Parser);

var _Form = require('../Observables/Form');

var _Form2 = _interopRequireDefault(_Form);

var _Hidden = require('../Hidden');

var _Hidden2 = _interopRequireDefault(_Hidden);

var _requiredMarker = require('./styled/required-marker');

var _requiredMarker2 = _interopRequireDefault(_requiredMarker);

var _validationMessage = require('./styled/validation-message');

var _validationMessage2 = _interopRequireDefault(_validationMessage);

var _textContent = require('./styled/text-content');

var _textContent2 = _interopRequireDefault(_textContent);

var _label = require('./styled/label');

var _label2 = _interopRequireDefault(_label);

var _formRow = require('./styled/form-row');

var _formRow2 = _interopRequireDefault(_formRow);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var WebformElement = (0, _mobxReact.observer)(_class = (_temp = _class2 = function (_Component) {
  (0, _inherits3.default)(WebformElement, _Component);

  function WebformElement(props) {
    (0, _classCallCheck3.default)(this, WebformElement);

    var _this = (0, _possibleConstructorReturn3.default)(this, (WebformElement.__proto__ || (0, _getPrototypeOf2.default)(WebformElement)).call(this, props));

    _this.key = props.field['#webform_key'];

    _this.onChange = _this.onChange.bind(_this);
    _this.onBlur = _this.onBlur.bind(_this);

    /**
     * @deprecated Don't use state! Use the store.
     */
    _this.state = {
      // errors: [],
    };
    /**
     * @deprecated
     */
    _this.setState = _this.setState;

    // Object.assign(this.state, defaultStates(props.field));
    return _this;
  }

  (0, _createClass3.default)(WebformElement, [{
    key: 'onChange',
    value: function onChange(e) {
      var field = this.getField();

      // First, check if this field has a value (e.g. fieldsets don't)
      var meta = field.componentClass.meta || {};
      var hasValue = meta.hasValue;
      if (typeof hasValue === 'undefined' || hasValue) {
        // Get the value
        var value = e && e.target ? e.target.value : e; // Check if 'e' is event, or direct value

        field.value = value;
      }

      this.props.onChange(e);

      return true;
    }
  }, {
    key: 'onBlur',
    value: function onBlur(e) {
      var field = this.getField();

      // First, check if this field has a value (e.g. fieldsets don't)
      var meta = field.componentClass.meta || {};
      var hasValue = meta.hasValue;
      if (typeof hasValue === 'undefined' || hasValue) {
        // Update the field storage to set it to blurred.
        field.isBlurred = true;
      }

      this.props.onBlur(e);
    }

    /**
     * @returns {Field}
     */

  }, {
    key: 'getField',
    value: function getField() {
      var key = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.key;

      return this.props.formStore.getField(key);
    }
  }, {
    key: 'getFormElement',
    value: function getFormElement() {
      var _this2 = this;

      if (!this.shouldRender()) {
        return false;
      }

      var ElementComponent = (0, _getNested2.default)(function () {
        return _this2.getField().componentClass;
      });
      if (ElementComponent) {
        return {
          class: ElementComponent,
          element: _react2.default.createElement(ElementComponent, (0, _extends3.default)({}, this.props, {
            value: this.getValue(),
            name: this.key,
            onChange: this.onChange,
            onBlur: this.onBlur,
            validations: this.state.validations,
            webformElement: this,
            state: this.getField()
          }))
        };
      }
      return false;
    }
  }, {
    key: 'getValue',
    value: function getValue() {
      var key = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.key;

      var field = this.getField(key);
      if (!field) {
        return false;
      }
      return field.getValue();
    }
  }, {
    key: 'getLabelDisplay',
    value: function getLabelDisplay() {
      var elementClass = this.getField().componentClass;
      return (0, _getNested2.default)(function () {
        return elementClass.meta.labelVisibility;
      }) || this.props.field['#title_display'] || 'inline';
    }

    /**
     * @deprecated
     * Just use this.getField().valid
     *
     * @param key
     * @returns {boolean}
     */

  }, {
    key: 'isValid',
    value: function isValid() {
      var key = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.key;

      var field = this.getField(key);
      if (!field) {
        return true;
      }
      return field.valid;
    }

    /**
     * @deprecated
     * Just use this.getField().isBlurred
     */

  }, {
    key: 'shouldValidate',
    value: function shouldValidate() {
      var force = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

      if (force) {
        return true;
      }
      var field = this.getField();
      if (!field) {
        return false;
      }
      return field.isBlurred;
    }
  }, {
    key: 'shouldRender',
    value: function shouldRender() {
      var _this3 = this;

      // If it is an admin only field, don't render.
      if (this.props.field['#admin']) {
        return false;
      }

      // Check if it is an composite element
      var children = (this.props.field.composite_elements || []).filter(function (e) {
        return !e['#admin'];
      });

      // If it is, check if there is any child that's visible or of type Hidden.
      if (children.length && !children.map(function (c) {
        return _this3.getField(c['#webform_key']);
      }).find(function (f) {
        return f && f.visible && f.componentClass !== _Hidden2.default;
      })) {
        // If there isn't any, don't render.
        return false;
      }

      // If all tests are passed, render.
      return true;
    }
  }, {
    key: 'isSuccess',
    value: function isSuccess() {
      return this.getField().isBlurred && this.isValid();
    }
  }, {
    key: 'renderTextContent',
    value: function renderTextContent(selector) {
      var checkValue = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
      var addClass = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : '';
      var show = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : true;

      if (show) {
        var field = this.getField().componentClass;
        var value = this.props.field[(0, _getNested2.default)(function () {
          return field.meta.field_display[selector];
        }, selector)]; // Value in #description field
        var displayValue = this.props.field[selector + '_display'];
        var cssClass = '' + selector.replace(/#/g, '').replace(/_/g, '-') + (checkValue ? '-' + checkValue : ''); // '#field_suffix' and 'suffix' become .field--suffix-suffix

        if (!value || !!checkValue && checkValue !== displayValue) {
          if (!(!displayValue && checkValue === 'isUndefined')) {
            return false;
          }
        }

        if (!value) {
          // don't output if there's no value
          return false;
        }

        return _react2.default.createElement(
          _textContent2.default,
          {
            value: cssClass,
            'class': addClass,
            labelDisplay: this.getLabelDisplay(),
            className: 'hrw-position-' + cssClass + ' hrw-label-display-' + this.getLabelDisplay()
          },
          (0, _Parser2.default)((0, _Parser.template)(this.props.formStore, value))
        );
      }

      return false;
    }
  }, {
    key: 'renderFieldLabel',
    value: function renderFieldLabel(element) {
      var show = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;

      /* If the label is a legend, it is supposed to be the first child of the fieldset wrapper. */

      if (this.props.field['#title'] && show) {
        var Wrapper = (0, _getNested2.default)(function () {
          return element.class.meta.label;
        }) || _label2.default;
        return _react2.default.createElement(
          Wrapper,
          { labelDisplay: this.getLabelDisplay(), htmlFor: this.key, className: 'hrw-label hrw-label-display-' + this.getLabelDisplay() },
          (0, _Parser2.default)((0, _Parser.template)(this.props.formStore, this.props.field['#title'])),
          this.getField().required ? _react2.default.createElement(
            _requiredMarker2.default,
            null,
            '\xA0*'
          ) : null
        );
      }

      return null;
    }
  }, {
    key: 'render',
    value: function render() {
      if (!this.shouldRender()) {
        return null;
      }

      var element = this.getFormElement();
      if (!element) return null;

      var errors = this.getField().errors.filter(function (error) {
        return error;
      });
      var errorList = errors.length > 0 ? _react2.default.createElement(
        _validationMessage2.default,
        { role: 'alert', labelDisplay: this.getLabelDisplay(), className: 'hrw-validation-message-wrapper' },
        errors
      ) : null;

      var Wrapper = (0, _getNested2.default)(function () {
        return element.class.meta.wrapper;
      }) || _formRow2.default;

      return _react2.default.createElement(
        Wrapper,
        (0, _extends3.default)({ hidden: !this.getField().visible, className: 'hrw-form-row' }, (0, _getNested2.default)(function () {
          return element.class.meta.wrapperProps;
        })),
        this.renderFieldLabel(element, (0, _getNested2.default)(function () {
          return element.class.meta.label.type;
        }) === 'legend'),
        this.renderTextContent('#description', 'before'),
        this.renderTextContent('#description', 'isUndefined', 'description-before', (0, _getNested2.default)(function () {
          return element.class.meta.label.type;
        }) === 'legend'),
        this.renderFieldLabel(element, (0, _getNested2.default)(function () {
          return element.class.meta.label.type;
        }) !== 'legend'),
        element.element,
        this.renderTextContent('#description', 'after', this.getLabelDisplay()),
        this.renderTextContent('#description', 'isUndefined', 'description-after', (0, _getNested2.default)(function () {
          return element.class.meta.label.type;
        }) !== 'legend'),
        errorList
      );
    }
  }]);
  return WebformElement;
}(_react.Component), _class2.propTypes = {
  field: _propTypes2.default.shape({
    '#type': _propTypes2.default.string.isRequired,
    '#default_value': _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.objectOf(_propTypes2.default.string)]),
    '#webform_key': _propTypes2.default.string.isRequired,
    '#required': _propTypes2.default.bool,
    '#pattern': _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.instanceOf(RegExp)]),
    '#requiredError': _propTypes2.default.string,
    '#patternError': _propTypes2.default.string,
    '#emailError': _propTypes2.default.string,
    '#title': _propTypes2.default.string,
    '#title_display': _propTypes2.default.string,
    '#options_display': _propTypes2.default.string,
    '#admin': _propTypes2.default.bool,
    composite_elements: _propTypes2.default.array
  }).isRequired,
  formStore: _propTypes2.default.instanceOf(_Form2.default).isRequired,
  onChange: _propTypes2.default.func,
  onBlur: _propTypes2.default.func,
  settings: _propTypes2.default.shape({
    custom_elements: _propTypes2.default.shape({
      patternError: _propTypes2.default.shape({
        '#default_value': _propTypes2.default.string,
        '#options': _propTypes2.default.objectOf(_propTypes2.default.string)
      })
    })
  }).isRequired,
  webformSettings: _propTypes2.default.shape().isRequired,
  webformPage: _propTypes2.default.string,
  form: _propTypes2.default.shape({
    settings: _propTypes2.default.object.isRequired
  }).isRequired,
  status: _propTypes2.default.string.isRequired,
  url: _propTypes2.default.string.isRequired
}, _class2.defaultProps = {
  label: false,
  parent: false,
  onChange: function onChange() {},
  onBlur: function onBlur() {},
  webformPage: 'none'
}, _temp)) || _class;

exports.default = WebformElement;